export default __webpack_public_path__ + "static/media/login.d29819d9.png";